import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CONFIGS } from "@/constants/configs";
import { useTranslations } from "@/providers/TranslationsProvider";
import { normalizeLicenceValue } from "@/lib/licence";
import { sessionLanguageLabel } from "@/utils/profile";
import { Chip, Field, FieldMessage, GroupLegend, INPUT, StepTitle, TEXTAREA } from "./fields";
import type { StepProps } from "./types";
export default function ProfileStep(t0) {
  const $ = _c(74);
  const {
    draft,
    update,
    errors
  } = t0;
  const {
    t
  } = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("join.optional", "Optional");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const optional = t1;
  let t2;
  if ($[2] !== draft.languages || $[3] !== update) {
    t2 = code => update({
      languages: draft.languages.includes(code) ? draft.languages.filter(c => c !== code) : [...draft.languages, code]
    });
    $[2] = draft.languages;
    $[3] = update;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleLanguage = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("join.profile title", "Your public profile");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("join.profile subtitle", "This is what patients see when they choose a doctor.");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <StepTitle title={t3} subtitle={t4} />;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("join.session languages", "Languages you hold sessions in");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <GroupLegend>{t6}</GroupLegend>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== draft.languages || $[17] !== toggleLanguage) {
    t8 = CONFIGS.i18n.supportedLanguages.map(code_0 => <Chip key={code_0} selected={draft.languages.includes(code_0)} onClick={() => toggleLanguage(code_0)}>{sessionLanguageLabel(code_0)}</Chip>);
    $[16] = draft.languages;
    $[17] = toggleLanguage;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <div className="flex flex-wrap gap-2">{t8}</div>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = errors["profile.languages"];
  let t11;
  if ($[21] !== t10) {
    t11 = <FieldMessage error={t10} />;
    $[21] = t10;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t7 || $[25] !== t9) {
    t12 = <fieldset>{t7}{t9}{t11}</fieldset>;
    $[23] = t11;
    $[24] = t7;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("join.headline", "Headline");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t) {
    t14 = t("join.headline hint", "One line, e.g. \"Clinical psychologist - anxiety & couples\"");
    $[29] = t;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  const t15 = !!draft.headline;
  let t16;
  if ($[31] !== update) {
    t16 = e => update({
      headline: e.target.value
    });
    $[31] = update;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== draft.headline || $[34] !== t16) {
    t17 = <input className={INPUT} value={draft.headline} maxLength={140} onChange={t16} />;
    $[33] = draft.headline;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  let t18;
  if ($[36] !== optional || $[37] !== t13 || $[38] !== t14 || $[39] !== t15 || $[40] !== t17) {
    t18 = <Field label={t13} hint={t14} optional={true} optionalText={optional} filled={t15}>{t17}</Field>;
    $[36] = optional;
    $[37] = t13;
    $[38] = t14;
    $[39] = t15;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  let t19;
  if ($[42] !== t) {
    t19 = t("join.bio", "About you");
    $[42] = t;
    $[43] = t19;
  } else {
    t19 = $[43];
  }
  const t20 = !!draft.bio;
  let t21;
  if ($[44] !== update) {
    t21 = e_0 => update({
      bio: e_0.target.value
    });
    $[44] = update;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== draft.bio || $[47] !== t21) {
    t22 = <textarea className={TEXTAREA} value={draft.bio} maxLength={5000} onChange={t21} />;
    $[46] = draft.bio;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== optional || $[50] !== t19 || $[51] !== t20 || $[52] !== t22) {
    t23 = <Field label={t19} optional={true} optionalText={optional} filled={t20} multiline={true}>{t22}</Field>;
    $[49] = optional;
    $[50] = t19;
    $[51] = t20;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t("join.experience", "Years of experience");
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const t25 = !!draft.years_of_experience;
  let t26;
  if ($[56] !== update) {
    t26 = e_1 => update({
      years_of_experience: normalizeLicenceValue(e_1.target.value).replaceAll(/\D/g, "")
    });
    $[56] = update;
    $[57] = t26;
  } else {
    t26 = $[57];
  }
  let t27;
  if ($[58] !== draft.years_of_experience || $[59] !== t26) {
    t27 = <input className={INPUT} inputMode="numeric" maxLength={2} value={draft.years_of_experience} onChange={t26} />;
    $[58] = draft.years_of_experience;
    $[59] = t26;
    $[60] = t27;
  } else {
    t27 = $[60];
  }
  let t28;
  if ($[61] !== optional || $[62] !== t24 || $[63] !== t25 || $[64] !== t27) {
    t28 = <Field label={t24} optional={true} optionalText={optional} filled={t25} dir="ltr" className="sm:max-w-[16rem]">{t27}</Field>;
    $[61] = optional;
    $[62] = t24;
    $[63] = t25;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== t12 || $[67] !== t18 || $[68] !== t23 || $[69] !== t28) {
    t29 = <div className="space-y-5">{t12}{t18}{t23}{t28}</div>;
    $[66] = t12;
    $[67] = t18;
    $[68] = t23;
    $[69] = t28;
    $[70] = t29;
  } else {
    t29 = $[70];
  }
  let t30;
  if ($[71] !== t29 || $[72] !== t5) {
    t30 = <section>{t5}{t29}</section>;
    $[71] = t29;
    $[72] = t5;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  return t30;
}